/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

import {GridFilterPanel, GridLogicOperator} from '@mui/x-data-grid-premium';

export const SuperTableFilter = (props: any) => {
  return (
    <GridFilterPanel
      {...props}
      logicOperators={[GridLogicOperator.And, GridLogicOperator.Or]}
      sx={{
        p: 1,
        pb: 0.5,
        '& .MuiDataGrid-filterForm': {
          alignItems: 'center',
        },
        '& .MuiDataGrid-filterFormDeleteIcon .MuiIconButton-root': {
          marginTop: '1rem',
        },
      }}
    />
  );
};
